import { isUndefined } from 'lodash-es';

import { Unit } from '@dynatrace-sdk/units';

import { BinMetadata, TooltipValueMetadata } from '../../../types/histogram.js';
import { getAbsoluteValue } from './get-absolute-value.js';

const isRelativeValueRepresentation = (
  absoluteValueMetadata: TooltipValueMetadata | undefined,
): absoluteValueMetadata is TooltipValueMetadata =>
  !isUndefined(absoluteValueMetadata);

export function getFormattedValues(
  formatter: (value: number, unit?: string | Unit) => string,
  binMetadata: BinMetadata,
) {
  const value = formatter(binMetadata.value, binMetadata.unit);

  return isRelativeValueRepresentation(binMetadata.absolute)
    ? [getAbsoluteValue(binMetadata.absolute, formatter).toString(), value]
    : [value.toString()];
}
